import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import PageBanner from '@components/Common/PageBanner';
import 'pannellum/build/pannellum.css';
import './Panorama360.css';

const Panorama360 = () => {
    const panoramas = [
        { id: 1, title: 'Marvel Residence', image: '/images/panorama1.jpg', location: 'Surat, Gujarat' },
        { id: 2, title: 'Apple Pool Villa', image: '/images/panorama2.jpg', location: 'Surat, Gujarat' },
        { id: 3, title: 'Dancing Column', image: '/images/panorama3.jpg', location: 'Surat, Gujarat' },
        { id: 4, title: 'Goji Farmhouse', image: '/images/panorama4.jpg', location: 'Gujarat' }
    ];

    const viewerRefs = useRef([]);

    useEffect(() => {
        // Dynamically import pannellum to avoid SSR issues
        import('pannellum').then((pannellum) => {
            panoramas.forEach((pano, index) => {
                const viewerDiv = viewerRefs.current[index];
                if (viewerDiv && !viewerDiv.classList.contains('pnlm-container')) {
                    try {
                        pannellum.viewer(viewerDiv, {
                            type: 'equirectangular',
                            panorama: pano.image,
                            autoLoad: true,
                            showControls: true,
                            showFullscreenCtrl: true,
                            showZoomCtrl: true,
                            mouseZoom: true,
                            draggable: true,
                            hotSpotDebug: false,
                            compass: true,
                            orientationOnByDefault: false,
                            hfov: 100,
                            pitch: 0,
                            yaw: 0
                        });
                    } catch (error) {
                        console.error(`Error loading panorama ${pano.id}:`, error);
                    }
                }
            });
        }).catch((error) => {
            console.error('Error loading Pannellum:', error);
        });

        return () => {
            viewerRefs.current = [];
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>360° Virtual Tours - AT Architects</title>
                <meta name="description" content="Experience our architectural projects through immersive 360-degree virtual tours." />
            </Helmet>

            <PageBanner
                title="360° Virtual Tours"
                subtitle="Immersive project experiences"
                backgroundImage="/images/360-banner.jpg"
            />

            <section className="panorama-section">
                <div className="panorama-container">
                    {panoramas.map((pano, index) => (
                        <div key={pano.id} className="panorama-item">
                            <div className="panorama-info">
                                <h3>{pano.title}</h3>
                                <p className="panorama-location">
                                    <i className="bi bi-geo-alt"></i> {pano.location}
                                </p>
                            </div>
                            <div
                                ref={(el) => (viewerRefs.current[index] = el)}
                                className="panorama-viewer"
                                style={{ width: '100%', height: '500px' }}
                            />
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default Panorama360;
